import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  handleRequestStart,
  handleRequestFailed,
  handleRequestSuccess,
} from "../redux/handleRequest";
import { handleRequestApi } from "core/http/service/timeKeeping";
import {
  selectHandleRequestData,
  selectMonthYearArriveLate,
  selectMonthYearListFeedbackManager,
  selectMonthYearRequestLeave,
} from "../redux/selector";
import { toast } from "react-toastify";
import { getListArriveLateManagerStart } from "../redux/getListArriveLateManager";
import { getListRequestLeaveManagerStart } from "../redux/getListRequestLeaveManager";
import { getListFeedbackManagerStart } from "../redux/getListFeedbackManager";
import { ErrorMessage } from "core/http/service/decleareLeave/const";

function* handleRequestWork(action) {
  const { isApprove, id } = yield select(selectHandleRequestData);
  const { tab, screenCode, ...body } = action.payload;
  const timeSelected =
    tab === "lack-of-time"
      ? yield select(selectMonthYearArriveLate)
      : tab === "list-feedback"
        ? yield select(selectMonthYearListFeedbackManager)
        : yield select(selectMonthYearRequestLeave);

  try {
    yield call(handleRequestApi, tab, { id, ...body }, screenCode);

    yield put({
      type: handleRequestSuccess.type,
    });
    toast.success(
      isApprove ? "Phê duyệt đơn thành công" : "Từ chối đơn thành công"
    );

    const payload = {
      month: timeSelected.month,
      year: timeSelected.year,
      limit: 60,
      offset: 0,
      screenCode,
    };

    yield put({
      type:
        tab === "lack-of-time"
          ? getListArriveLateManagerStart.type
          : tab === "list-feedback"
            ? getListFeedbackManagerStart.type
            : getListRequestLeaveManagerStart.type,
      payload,
    });
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: handleRequestFailed.type,
    });
  }
}

function* watchHandleRequest() {
  yield takeLatest(handleRequestStart.type, handleRequestWork);
}

export default function* handleRequestSaga() {
  yield all([watchHandleRequest()]);
}
